import './info-teaser-list.scss';

import { Navigation, A11y } from 'swiper/modules';

class InfoTeaserList {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-infoteaserlist'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$infoTeaserList = $element;
        this.$sliderWrapper = this.$infoTeaserList.querySelector('[' + this.settings.initAttr + '="slider"]');
        this.$slides = this.$infoTeaserList.querySelectorAll('[' + this.settings.initAttr + '="slide"]');
        this.$slider = null;

        this.resizeHandler = window.resizeHandler;
        this.sliderActive = false;

        if (this.$slides.length > 1) {
            import(
                /* webpackChunkName: "slider/slider.js" */
                './../../components/slider/slider').then(({ Slider }) => {
                this.Slider = Slider;
                this.initialize();
            });
        }
        // this.initialize();
    }

    initialize () {
        console.log('InfoTeaserList');
        this.checkSize();
        this.resizeHandler.customFunctions.push(() => {
            this.checkSize();
        });
    }

    checkSize () {
        if (window.innerWidth < 768 && this.$slides.length > 1) {
            if (this.sliderActive === false) {
                this.initSlider();
            }
        } else if (window.innerWidth < 1024 && this.$slides.length > 2) {
            if (this.sliderActive === false) {
                this.initSlider();
            }
        } else {
            if (this.sliderActive === true) {
                this.destroySlider();
                this.sliderActive = false;
            }
        }
    }

    initSlider () {
        this.$slider = new this.Slider(this.$sliderWrapper, {
            modules: [A11y, Navigation],
            speed: 500,
            slidesPerView: 'auto',
            prevNext: true,
            slidesPerGroup: 1,
            centeredSlides: true,
            centeredSlidesBounds: true,
            initAttr: this.settings.initAttr,
            centerInsufficientSlides: true,
            breakpoints: {
                768: {
                    slidesPerGroup: 2,
                    centeredSlides: false
                }
            }
        });

        this.sliderActive = true;
    }

    destroySlider () {
        if (typeof this.$slider !== 'undefined' && this.$slider !== null) {
            this.$slider.destroy();
        }
    }
}

export { InfoTeaserList };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$infoTeaserList = $context.querySelectorAll('[data-infoteaserlist="root"]');
        for (let i = 0; i < $$infoTeaserList.length; i++) {
            const $infoTeaserList = $$infoTeaserList[i];

            const infoTeaserListAPI = new InfoTeaserList($infoTeaserList);
            $infoTeaserList.API = infoTeaserListAPI;
        }
    }
});
